import { useSelector } from "react-redux";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import SoftButton from "components/SoftButton";
import { convertMarkdownToHtml } from "helpers/markdown";

export const DocumentationDialog = ({ selectedNode, isOpen, closeDialog }) => {
  const components = useSelector((store) => store.designer.cxfComponents.components);
  const foundComponent = components.find(
    (component) => component.id === selectedNode?.data?.componentId
  );

  const htmlContent = convertMarkdownToHtml(foundComponent?.documentation ?? "");

  return (
    <>
      <Dialog open={isOpen} fullWidth={true} maxWidth="md">
        <DialogTitle sx={{ paddingLeft: "32px" }}>Documentation</DialogTitle>
        <DialogContent dividers={true}>
          <div className="markdown-rendered-content" dangerouslySetInnerHTML={{ __html: htmlContent }} />
        </DialogContent>
        <DialogActions>
          <SoftButton variant="outlined" color="info" onClick={closeDialog}>
            Close
          </SoftButton>
        </DialogActions>
      </Dialog>
    </>
  );
};
